import React from "react";
import ProjectList, { Project as ProjectListItem } from "./ProjectList";
import { PortfolioContent } from "../data/content";
import "../assets/styles/Project.scss";

interface ProjectProps {
  content: PortfolioContent["projects"];
}

function Project({ content }: ProjectProps) {
  const getImageUrl = (path: string) => {
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    const cleanPath = path.replace(/^\//, '');
    return process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/${cleanPath}` : `/${cleanPath}`;
  };

  const projectsData: ProjectListItem[] = content.items.map((item) => ({
    title: item.title,
    category: item.type,
    ...(item.year ? { year: item.year } : {}),
    ...(item.image ? { image: getImageUrl(item.image) } : {}),
    ...(item.secondaryImage ? { secondaryImage: getImageUrl(item.secondaryImage) } : {}),
    ...(item.liveUrl ? { url: item.liveUrl } : {}),
    ...(item.showcase ? { showcase: item.showcase } : {}),
    ...(item.summary ? { summary: item.summary } : {}),
    ...(item.note ? { note: item.note } : {}),
    color: "#f5f5f5",
  }));

  return (
    <div className="projects-wrapper" id="projects">
      <div className="projects-container">
        <h1>{content.heading}</h1>
        <p className="section-subtitle">{content.subtitle}</p>
        <ProjectList
          projects={projectsData}
          cursorLabel={content.cursorLabel || "Zobacz"}
        />
      </div>
    </div>
  );
}

export default Project;